export default {
	meta: {
		title: 'Erreur 404',
		description: 'Page non trouvée.'
	},
	code: '404',
	error: 'Page non trouvée',
	message: 'Il semblerait qu\'il y ait eu une erreur !',
	cta: 'Retour à la page d\'accueil'
};
